export enum CouponStyle {
  BASIC = 'Basic',
  IMAGE = 'Image',
  NEWSPAPER = 'Newspaper',
  //Inline is not returned from the server. Just for client use.
  INLINE = 'Inline',
}
